export const casinoTabs = {
  livecasino: {
    AndarBahar: {
      href: "/casino/aggapezugi-andar-bahar",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/livecasino/AndarBahar.webp",
      name: "Andar Bahar",
    },
    Supersicbo: {
      href: "/casino/aggapevolutiongaming-super-sic-bo-u9412",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/livecasino/supersicbo.webp",
      name: "Super Sic Bo",
    },
    GoldVaultRoulette: {
      href: "/casino/aggapevolutiongaming-gold-vault-roulette",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/livecasino/goldvaultroulette.webp",
      name: "Gold Vault Roulette",
    },
    AutoClawRoulette: {
      href: "/casino/aggapezugi-auto-claw-roulette",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/livecasino/autoclawroulette.webp",
      name: "Auto Claw Roulette",
    },
    SkylineRoulette: {
      href: "/casino/aggapezugi-skyline-roulette",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/livecasino/skylineroulette.webp",
      name: "Skyline Roulette",
    },
    ItalianRoulette: {
      href: "/casino/aggapezugi-italian-roulette",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/livecasino/italianroulette.webp",
      name: "Italian Roulette",
    },
    Lucky7: {
      href: "/casino/aggapezugi-lucky-7",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/livecasino/lucky7.webp",
      name: "Lucky 7",
    },
    CricketWar: {
      href: "/casino/aggapezugi-cricket-war",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/livecasino/cricketwar.webp",
      name: "Cricket War",
    },
    CrazyCoinFlip: {
      href: "/casino/aggapevolutiongaming-crazy-coin-flip-u8511",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/livecasino/crazycoinflip.webp",
      name: "Crazy Coin Flip",
    },
  },

  sports: {
    Cricket: {
      href: "/sports/jetfair?sportName=cricket",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/sports/SportsExch.png",
      name: "Cricket",
    },
    Football: {
      href: "/sports/jetfair?sportName=soccer",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/sports/football.png",
      name: "Football",
    },
    Tennis: {
      href: "/sports/jetfair?sportName=tennis",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/sports/tennis.png",
      name: "Tennis",
    },
    Basketball: {
      href: "/sports/ig_pixel?slug=igp-pre-match-53",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/sports/basketball.png",
      name: "Basketball",
    },
    Badminton: {
      href: "/sports/ig_pixel?slug=igp-pre-match-56",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/sports/shuttlecock.png",
      name: "Badminton",
    },
    Baseball: {
      href: "/sports/ig_pixel?slug=igp-pre-match-56",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/sports/baseball.png",
      name: "Baseball",
    },
    Darts: {
      href: "/sports/ig_pixel?slug=igp-pre-match-69",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/sports/target.png",
      name: "Darts",
    },
    TableTennis: {
      href: "/sportsbook/TableTennis",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/sports/table-tenis.png",
      name: "Table Tennis",
    },
  },

  hotminigames: {
    // Aviator: {
    //   href: "/casino/aggapspribe-aviator",
    //   code: "",
    //   casino: "",
    //   provider: "",
    //   homeUrl: "",
    //   imgUrl: "./images/casino/hotminigames/aviator.webp",
    //   name: "Aviator",
    // },
    // JetX: {
    //   href: "/casino/aggapsmartsoftgaming-jetx",
    //   code: "",
    //   casino: "",
    //   provider: "",
    //   homeUrl: "",
    //   imgUrl: "./images/casino/hotminigames/jetx.webp",
    //   name: "JetX",
    // },
    // Goal: {
    //   href: "/casino/aggapspribe-goal",
    //   code: "",
    //   casino: "",
    //   provider: "",
    //   homeUrl: "",
    //   imgUrl: "./images/casino/hotminigames/goal.webp",
    //   name: "Goal",
    // },
    // Aero: {
    //   href: "/casino/aggapturbogames-aero",
    //   code: "",
    //   casino: "",
    //   provider: "",
    //   homeUrl: "",
    //   imgUrl: "./images/casino/hotminigames/aero.webp",
    //   name: "Aero",
    // },
    // FastFielder: {
    //   href: "/casino/aggapturbogames-fast-fielder",
    //   code: "",
    //   casino: "",
    //   provider: "",
    //   homeUrl: "",
    //   imgUrl: "./images/casino/hotminigames/fastfilelder.webp",
    //   name: "Fast Fielder",
    // },
    // Colors: {
    //   href: "/casino/aggaphacksawgaming-colors-u1197",
    //   code: "",
    //   casino: "",
    //   provider: "",
    //   homeUrl: "",
    //   imgUrl: "./images/casino/hotminigames/color.webp",
    //   name: "Colors",
    // },
    // DoubleRoll: {
    //   href: "/casino/aggapturbogames-double-roll",
    //   code: "",
    //   casino: "",
    //   provider: "",
    //   homeUrl: "",
    //   imgUrl: "./images/casino/hotminigames/doubleroll.webp",
    //   name: "Double Roll",
    // },
    // CricketX: {
    //   href: "/casino/aggapsmartsoftgaming-cricketx",
    //   code: "",
    //   casino: "",
    //   provider: "",
    //   homeUrl: "",
    //   imgUrl: "./images/casino/hotminigames/cricketx.webp",
    //   name: "CricketX",
    // },
    speedautoroulette: {
      href: "/casino/aggapevolutiongaming-speed-auto-roulette",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/hotminigames/SpeedAutoRoulette-Evo.webp",
      name: "Speed Auto Roulette",
    },
    crazytime: {
      href: "/casino/aggapevolutiongaming-crazy-time",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/hotminigames/CrazyTime-Evo.webp",
      name: "Crazy Time",
    },
    Monopoly: {
      href: "/casino/aggapevolutiongaming-monopoly-live",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/hotminigames/Monopolylive-Evo.webp",
      name: "Monopoly",
    },
    andarbahar: {
      href: "/casino/aggapezugi-andar-bahar",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/hotminigames/andarbahar-ez.webp",
      name: "Andar Bahar",
    },
    baccarat: {
      href: "/casino/aggapezugi-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/hotminigames/baccarat-ez.webp",
      name: "Baccarat",
    },
    speedautorouletteezg: {
      href: "/casino/aggapezugi-speed-auto-roulette",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/hotminigames/autoroulette-ez.webp",
      name: "Speed Auto Roulette",
    },
  },

  tablegames: {
    UpDown7: {
      href: "/casino/aggapkingmaker-7-up-7-down",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/tablegames/7up7down.webp",
      name: "7 Up 7 Down",
    },
    CoinToss: {
      href: "/casino/km-coin-toss",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/tablegames/cointoss.webp",
      name: "Coin Toss",
    },
    AndarBahar: {
      href: "/casino/km-andar-bahar",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/tablegames/AndarBaharKingmaker.webp",
      name: "Andar Bahar",
    },
    TeenPatti: {
      href: "/casino/aggapjiligaming-teenpatti",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/tablegames/teenpatti.webp",
      name: "TeenPatti",
    },
    Dragon_Tiger: {
      href: "/casino/dc-dragon-and-tiger",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino/tablegames/dragon&tigerjili.webp",
      name: "Dragon & Tiger",
    },
    SpeedRoulette: {
      href: "/casino/aggapevolutiongaming-speed-roulette",
      code: "",
      casino: "ezugi",
      provider: "ezugi",
      providerName: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/ezugi/roulette/SpeedRoulette.webp",
      alt: "Speed Roulette",
      name: "Speed Roulette",
    },
    AmericanRoulette: {
      href: "/casino/ezgevo-american-roulette",
      code: "",
      casino: "ezugi",
      provider: "evolution",
      providerName: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/evolution/roulette/AmericanRoulette.webp",
      alt: "American Roulette",
      name: "American Roulette",
    },
  },

  roulettetab: {
    RouletteVip: {
      href: "/casino/evolution/RouletteVip",
      code: "1000124",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino02.png", alt: "" },
    },

    RouletteLive: {
      href: "/casino/evolution/RouletteLive",
      code: "1000102",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino03.png", alt: "" },
    },
    AmericanRoulette: {
      href: "/casino/evolution/AmericanRoulette",
      code: "1000011",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino04.png", alt: "" },
    },
    AmericanRouletteFirstPerson: {
      href: "/casino/evolution/AmericanRouletteFirstPerson",
      code: "1000312",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino08.png", alt: "" },
    },
    LightningRouletteFirstPerson: {
      href: "/casino/evolution/LightningRouletteFirstPerson",
      code: "1000120",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino05.png", alt: "" },
    },
    LightingsRoulette: {
      href: "/casino/evolution/LightingRoulette",
      code: "1000092",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino015.png", alt: "" },
    },
    AutoRouletteLive: {
      href: "/casino/evolution/doubleballroulette",
      code: 507000,
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino014.png", alt: "" },
    },
    LightingRoulette: {
      href: "/casino/evolution/LightingRoulette",
      code: "1000120",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/casino01111.png",
        alt: "",
      },
    },
    namasteroulette: {
      href: "/casino/ezugi/namasteroulette",
      code: 221005,
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casinio28.png", alt: "" },
    },

    AutoRouletteLive: {
      href: "/casino/evolution/DoubleBallRouletteLive",
      code: "1000104",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino070.PNG", alt: "" },
    },

    PortmasoRoulette: {
      href: "/casino/evolution/PortmasoRoulette",
      code: 611004,
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino013.png", alt: "" },
    },
    marinaroulette: {
      href: "/casino/ezugi/marinaroulette",
      code: 321000,
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino019.png", alt: "" },
    },

    OracleRoulette360: {
      href: "/casino/ezugi/OracleRoulette360",
      code: "611003",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino030.png", alt: "" },
    },
    diamondroulette: {
      href: "/casino/ezugi/diamondroulette",
      code: "221003",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino028.png", alt: "" },
    },
    speedroulette: {
      href: "/casino/ezugi/speedroulette",
      code: "221000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino029.PNG", alt: "" },
    },

    oracleRoulette: {
      href: "/casino/ezugi/oracleRoulette",
      code: "611001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino010.png", alt: "" },
    },
    AutoRoulette1: {
      href: "/casino/ezugi/AutoRoulette1",
      code: "5001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino026.png", alt: "" },
    },
    cumbiaRoulette: {
      href: "/casino/ezugi/cumbiaRoulette",
      code: "411000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/casino031.png",
        alt: "",
        className: "size_images",
      },
    },
    PrestigeAutoRoulette: {
      href: "/casino/ezugi/PrestigeAutoRoulette",
      code: "221004",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino014.png", alt: "" },
    },
    FiestaRoulette: {
      href: "/casino/ezugi/FiestaRoulette",
      code: "431001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino012.png", alt: "" },
    },

    HandCasinoHoldem: {
      href: "/casino/evolution/HandCasinoHoldem",
      code: 507000,
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino011.png", alt: "" },
    },
    HandCasinoHoldem: {
      href: "/casino/ezugi/autoRoulette",
      code: "221002",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino032.PNG", alt: "" },
    },

    TurkishsRoulettes: {
      href: "/casino/evolution/TurkishsRoulettes",
      code: 507000,
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino017.png", alt: "" },
    },

    Roulettelive: {
      href: "/casino/evolution/Roulettelive",
      code: "1",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/roulette/casino033.png", alt: "" },
    },
    autORoulette: {
      href: "/casino/ezugi/autORoulette",
      code: "1",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/roulette/casino035.png", alt: "" },
    },
    Dragonroulette: {
      href: "/casino/xpg/Dragonroulette",
      code: "",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/roulette/casino023.png", alt: "" },
    },
    LiveSpeedRoulette: {
      href: "/casino/ezugi/LiveSpeedRoulette",
      code: "221000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino032.PNG", alt: "" },
    },

    LightingLiveRoulette: {
      href: "/casino/evolution/LightingLiveRoulette",
      code: 507000,
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/casino022.png", alt: "" },
    },
    Roulette: {
      href: "/casino/evolution/Roulette",
      code: "RT",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/roulette/casino078.PNG", alt: "" },
    },

    americanRouletLive: {
      href: "/casino/evolution/americanRouletLive",
      code: "RT",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/roulette/casino076.PNG", alt: "" },
    },
    autoRouletteLive: {
      href: "/casino/evolution/autoRouletteLive",
      code: "RT",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/roulette/casino077.PNG", alt: "" },
    },
    AutoFastRouletLive: {
      href: "/casino/evolution/AutoFastRouletLive",
      code: "RT",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/roulette/casino075.PNG", alt: "" },
    },
  },
  baccarattab: {
    Baccaratpro: {
      href: "/casino/evolution/Baccaratfirstperson",
      code: "1000145",
      casino: "ezugi",
      provider: "EVO_LOBBY",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino027.png", alt: "" },
    },
    Nocommissiobaccarat: {
      href: "/casino/ezugi/Nocommissiobaccarat",
      code: "170",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino028.png", alt: "" },
    },
    Knockoutbaccarat: {
      href: "/casino/ezugi/Knockoutbaccarat",
      code: "120",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino029.png", alt: "" },
    },
    baccaratLive: {
      href: "/casino/evolution/baccaratLive",
      code: "1000012",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino0011.PNG", alt: "" },
    },
    Marinabaccarat: {
      href: "/casino/ezugi/Marinabaccarat",
      code: "130",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino031.png", alt: "" },
    },

    Marinabaccarat: {
      href: "/casino/ezugi/Marinabaccarat",
      code: "130",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino031.png", alt: "" },
    },

    KnockOutbaccarat: {
      href: "/casino/ezugi/KnockOutbaccarat",
      code: "120",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino029.png", alt: "" },
    },
    noCommisionBaccarat: {
      href: "/casino/ezugi/noCommisionBaccarat",
      code: "170",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino027.png", alt: "" },
    },
    Baccarat: {
      href: "/casino/evolution/Baccarat",
      code: "BAC",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino080.PNG", alt: "" },
    },
    Baccaratpro: {
      href: "/casino/evolution/Baccaratpro",
      code: "1000145",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino040.png", alt: "" },
    },
    Nocommissiobaccarat: {
      href: "/casino/evolution/Nocommissiobaccarat",
      code: "10",
      casino: "ezugi",
      provider: "EVO_LOBBY",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino041.png", alt: "" },
    },
    Knockoutbaccarat: {
      href: "/casino/evolution/Knockoutbaccarat",
      code: "",
      casino: "ezugi",
      provider: "EVO_LOBBY",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino042.PNG", alt: "" },
    },
    baccaratlive: {
      href: "/casino/ezugi/baccaratlive",
      code: "10",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino028.png", alt: "" },
    },
    Marinabaccarat: {
      href: "/casino/ezugi/Marinabaccarat",
      code: "32100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/casino031.png", alt: "" },
    },
    // Baccaratpro02: {
    //   href: "/casino/ezugi/Baccaratpro02",
    //   code: "101",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/baccarat/casino028.png", alt: "" },
    // },
    // SpeedBaccarat: {
    //   href: "/casino/ezugi/SpeedBaccarat",
    //   code: "105",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/baccarat/casino029.png", alt: "" },
    // },
    // Marina03baccarat: {
    //   href: "/casino/ezugi/Marina03baccarat",
    //   code: "32103",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/baccarat/baccarat010.png", alt: "" },
    // },
  },
  AndarBahartab: {
    AndarBaharLive: {
      href: "/casino/ezugi/AndarBaharLive",
      code: "228000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/andarbahar/casino032.png", alt: "" },
    },
    AndarBaharlive: {
      href: "/casino/ezugi/AndarBaharlive",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/andarbahar/casino030.png", alt: "" },
    },
    AndarBahar: {
      href: "/casino/ezugi/AndarBahar",
      code: "ABC",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/andarbahar/casino091.PNG", alt: "" },
    },
    GoaAndarBahar: {
      href: "/casino/ezugi/GoaAndarBahar",
      code: "AB2",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/andarbahar/casino090.PNG", alt: "" },
    },
    Andarbahar: {
      href: "/casino/evolution/Andarbahar",
      code: "",
      casino: "ezugi",
      provider: "EVO_LOBBY",
      homeUrl: "",
      cover: { src: "./images/andarbahar/casino0112.png", alt: "" },
    },
    Andarbaharlive: {
      href: "/casino/evolution/Andarbaharlive",
      code: "",
      casino: "ezugi",
      provider: "EVO_LOBBY",
      homeUrl: "",
      cover: { src: "./images/andarbahar/casino0113.png", alt: "" },
    },
    AndarbaharLive: {
      href: "/casino/xpg/AndarbaharLive",
      code: "328000",
      casino: "wco",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/andarbahar/casino0115.png", alt: "" },
    },
    AndarBaharlivee: {
      href: "/casino/xpg/AndarBaharlivee",
      code: "328000",
      casino: "wco",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/andarbahar/casino0114.png", alt: "" },
    },
  },
  TeenPattitab: {
    TeenPatti01: {
      href: "/casino/ezugi/TeenPatti01",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/casino033.png", alt: "" },
    },
    TeenPatti02: {
      href: "/casino/ezugi/TeenPatti02",
      code: "507000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/casino061.png", alt: "" },
    },
    TeenPatti03: {
      href: "/casino/ezugi/TeenPatti03",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/casino032.png", alt: "" },
    },
    TeenPatti03: {
      href: "/casino/xpg/TeenPatti03",
      code: "227103",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/poker/casino034.png", alt: "" },
    },
    TeenPatti04: {
      href: "/casino/xpg/TeenPatti04",
      code: "227103",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/poker/casino031.png", alt: "" },
    },
    TeenPatti05: {
      href: "/casino/xpg/TeenPatti05",
      code: "227103",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/poker/casino035.png", alt: "" },
    },
    TeenPatti06: {
      href: "/casino/xpg/TeenPatti06",
      code: "227103",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/poker/casino032.png", alt: "" },
    },
    Poker: {
      href: "/casino/ezugi/Poker",
      code: "PK",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/poker/casino093.PNG", alt: "" },
    },
    ThreeTeenPatti: {
      href: "/casino/ezugi/ThreeTeenPatti",
      code: "V3TP",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/poker/casino094.PNG", alt: "" },
    },
    TeenPatti09: {
      href: "/casino/ezugi/TeenPatti09",
      code: "TP",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/poker/casino092.PNG", alt: "" },
    },
  },
  Blackjacktab: {
    Blackjack: {
      href: "/casino/evolution/Blackjack",
      code: "1000048",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino060.png", alt: "" },
    },

    GoldBlackjack: {
      href: "/casino/ezugi/GoldBlackjack",
      code: "1",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino040.png", alt: "" },
    },
    vipBlackjack: {
      href: "/casino/ezugi/vipBlackjack",
      code: "224",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino039.png", alt: "" },
    },
    italianBlackjack: {
      href: "/casino/ezugi/italianBlackjack",
      code: "226",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino053.png", alt: "" },
    },
    unlimitedblackjack: {
      href: "/casino/ezugi/unlimitedblackjack",
      code: "51",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino043.png", alt: "" },
    },
    TurkceBlackjack: {
      href: "/casino/ezugi/TurkceBlackjack",
      code: "422",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino044.png", alt: "" },
    },
    rumbablackjack: {
      href: "/casino/ezugi/rumbablackjack",
      code: "411",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino050.png", alt: "" },
    },
    RumbaBlackjack: {
      href: "/casino/ezugi/RumbaBlackjack",
      code: "411",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino046.png", alt: "" },
    },
    goldBlackjack: {
      href: "/casino/xpg/goldBlackjack",
      code: "11",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino042.png", alt: "" },
    },
    BlackjackLive: {
      href: "/casino/ezugi/Blackjacklive",
      code: "414",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino099.PNG", alt: "" },
    },
    VipBlackjack: {
      href: "/casino/evolution/Blackjack",
      code: "1000048",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino060.png", alt: "" },
    },
    Blackjacklivee: {
      href: "/casino/evolution/Blackjacklivee",
      code: "1000032",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino0222.png", alt: "" },
    },
    BlackJacklivee: {
      href: "/casino/evolution/BlackJacklivee",
      code: "1000031",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino0223.png", alt: "" },
    },
    BlackjackLive: {
      href: "/casino/supernowa/BlackjackLive",
      code: "422",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino099.PNG", alt: "" },
    },
    GoldBlackjackLive: {
      href: "/casino/ezugi/GoldBlackjackLive",
      code: "11",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino042.png", alt: "" },
    },
    PlaastinumBlackjacksss: {
      href: "/casino/ezugi/PlaastinumBlackjacksss",
      code: "11",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino0224.png", alt: "" },
    },
    ItasasdlianBlackjackaasas: {
      href: "/casino/ezugi/ItasasdlianBlackjackaasas",
      code: "11",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/blackjack/casino0225.png", alt: "" },
    },
  },
  thirtytwoCardtab: {
    thirtytwoCards: {
      href: "/casino/ezugi/thirtytwoCards",
      code: "228002",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/card/casino057.png", alt: "" },
    },
    thirtytwoCardss: {
      href: "/casino/ezugi/thirtytwoCardss",
      code: "C32",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/card/casino0100.PNG", alt: "" },
    },
  },
  sevenLuckytab: {
    luckyseven: {
      href: "/casino/ezugi/luckyseven",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/lucky7/casino056.png", alt: "" },
    },
    Lucky: {
      href: "/casino/supernowa/Lucky-7",
      code: "VUD7",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/lucky7/casino100.PNG", alt: "" },
    },
  },
  sicbotab: {
    supersicbo: {
      href: "/casino/evolution/supersicbo",
      code: "1000110",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/dice/casino060.png", alt: "" },
    },
    craps: {
      href: "/casino/evolution/craps",
      code: "1000248",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/dice/casino0132.png", alt: "" },
    },
    lightningdice: {
      href: "/casino/evolution/lightningdice",
      code: "1000076",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/dice/casino062.png", alt: "" },
    },
    ultimatesicbo: {
      href: "/casino/ezugi/ultimatesicbo",
      code: "224100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/dice/casino058.png", alt: "" },
    },
    sicbodice04: {
      href: "/casino/xpg/sicbodice04",
      code: "38",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/dice/casino059.png", alt: "" },
    },
    sicbo: {
      href: "/casino/supernowa/sicbo",
      code: "38",
      casino: "wco",
      provider: "SN",
      homeUrl: "",
      cover: { src: "./images/dice/casino101.PNG", alt: "" },
    },
  },
  BetOnNumberTab: {
    BetOnNumberHd: {
      href: "/casino/ezugi/BetOnNumberHd",
      code: "602000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/games/casino035.png", alt: "" },
    },
    CrazyTime: {
      href: "/casino/evolution/CrazyTime",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/games/casino039.png", alt: "" },
    },
    DreamCatcher: {
      href: "/casino/evolution/DreamCatcher",
      code: "1000077",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/games/casino0227.png", alt: "" },
    },
    MonopolyLive: {
      href: "/casino/evolution/MonopolyLive",
      code: "1000077",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/games/casino0229.png", alt: "" },
    },
    WheelOfFortune: {
      href: "/casino/xpg/WheelOfFortune",
      code: "224100",
      casino: "wco",
      provider: "XPG",
      homeUrl: "",
      cover: { src: "./images/games/casino0228.png", alt: "" },
    },
  },
  indianGames: {
    IndianNamasteRoulette: {
      href: "/casino/ezugi/IndianNamasteRoulette",
      code: "221005",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/indian/01.jpg", alt: "" },
    },
    IndianTeenPatti: {
      href: "/casino/ezugi/IndianTeenPatti",
      code: "227100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/indian/02.jpg", alt: "" },
    },

    onedayteenpatti: {
      href: "/casino/ezugi/onedayteenpatti",
      code: "227102",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/indian/03.jpg", alt: "" },
    },
    thirty2cards: {
      href: "/casino/ezugi/thirty2cards",
      code: "228002",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/indian/04.jpg", alt: "" },
    },
    beton: {
      href: "/casino/ezugi/beton",
      code: "227101",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/indian/05.jpg", alt: "" },
    },
    oneday: {
      href: "/casino/ezugi/oneday",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/indian/06.jpg", alt: "" },
    },
  },
  spribeGames1: {
    aviator: {
      // redirectUrl: "/casino/aggapspribe-aviator",
      redirectUrl: "/casino/aggapspribe-aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Aviator-new.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    goal: {
      // redirectUrl: "/casino/aggapspribe-goal",
      redirectUrl: "/casino/aggapspribe-goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Goal-new.webp",
      alt: "",
      name: "Goal",
      providerName: "Spribe",
    },
    dice: {
      // redirectUrl: "/casino/aggapspribe-dice",
      redirectUrl: "/casino/aggapspribe-dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Dice-new.webp",
      alt: "",
      name: "Dice",
      providerName: "Spribe",
    },
    plinko: {
      // redirectUrl: "/casino/aggapspribe-plinko",
      redirectUrl: "/casino/aggapspribe-plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Plinko-new.webp",
      alt: "",
      name: "Plinko",
      providerName: "Spribe",
    },
    hilo: {
      // redirectUrl: "/casino/aggapspribe-hilo",
      redirectUrl: "/casino/aggapspribe-hilo",
      code: "hi-lo",
      casino: "spribe",
      provider: "hi-lo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Hilo-new.webp",
      alt: "",
      name: "Hilo",
      providerName: "Spribe",
    },
    keno: {
      // redirectUrl: "/casino/aggapspribe-keno",
      redirectUrl: "/casino/aggapspribe-keno",
      code: "keno",
      casino: "spribe",
      provider: "keno",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Keno-new.webp",
      alt: "keno",
      name: "Keno",
      providerName: "Spribe",
    },
    miniroulette: {
      // redirectUrl: "/casino/aggapspribe-miniroulette",
      redirectUrl: "/casino/aggapspribe-mini-roulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/MiniRoulette-new.webp",
      alt: "",
      name: "Mini Roulette",
      providerName: "Spribe",
    },

    mines: {
      // redirectUrl: "/casino/aggapspribe-mines",
      redirectUrl: "/casino/aggapspribe-mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Mines.webp",
      alt: "",
      name: "Mines",
      providerName: "Spribe",
    },
    hotline: {
      // redirectUrl: "/casino/aggapspribe-hotline",
      redirectUrl: "/casino/aggapspribe-hotline",
      code: "hotline",
      casino: "spribe",
      provider: "hotline",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/HotlineNew.jpg",
      alt: "hotline",
      name: "Hotline",
      providerName: "Spribe",
    },
    PilotChicken: {
      redirectUrl: "/casino/aggapspribe-pilot-chicken",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/pilotchicken.webp",
      alt: "Pilot Chicken",
      name: "Pilot Chicken",
    },
    GatesofEgypt: {
      redirectUrl: "/casino/aggapspribe-gates-of-egypt",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/gatesofegypt.webp",
      alt: "Gates of Egypt",
      name: "Gates of Egypt",
    },
    NeoVegas: {
      redirectUrl: "/casino/aggapspribe-neo-vegas",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/neovegas.webp",
      alt: "Neo Vegas",
      name: "Neo Vegas",
    },
    CrystalsFall: {
      redirectUrl: "/casino/aggapspribe-crystal-fall",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/crystalfall.webp",
      alt: "Crystal Fall",
      name: "Crystal Fall",
    },
    Trader: {
      redirectUrl: "/casino/aggapspribe-trader",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/trader.webp",
      alt: "Trader",
      name: "Trader",
    },
    Keno80: {
      redirectUrl: "/casino/aggapspribe-keno-80",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/multikeno.webp",
      alt: "Keno 80",
      name: "Keno 80",
    },
    Balloon: {
      redirectUrl: "/casino/aggapspribe-balloon",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/balloon.webp",
      alt: "Balloon",
      name: "Balloon",
    },
  },
  popularGames: {
    lucky7: {
      href: "/casino/ezugi/lucky7",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/popular/01.jpg", alt: "" },
    },
    Monopoly: {
      href: "/casino/evolution/Monopoly",
      code: "228001",
      casino: "ezugi",
      provider: "EVO_LOBBY",
      homeUrl: "",
      cover: { src: "./images/popular/02.jpg", alt: "" },
    },

    Dragontiger: {
      href: "/casino/ezugi/Dragontiger",
      code: "150",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/popular/03.jpg", alt: "" },
    },
    Speed: {
      href: "/casino/ezugi/Speed",
      code: "221000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/popular/04.jpg", alt: "" },
    },
    teenpatti3card: {
      href: "/casino/ezugi/teenpatti3card",
      code: "227100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/popular/05.jpg", alt: "" },
    },
    // Miniroulette2: {
    //   href: "/casino/ezugi/Miniroulette2",
    //   code: "228001",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/popular/06.jpg", alt: "" },
    // },
    thirty2cards: {
      href: "/casino/ezugi/thirty2cards",
      code: "228002",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/indian/04.jpg", alt: "" },
    },
  },
  slotsgames: {
    twinspin: {
      href: "/casino/ezugi/twinspin",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/01.jpg", alt: "" },
    },
    gonzoquest: {
      href: "/casino/ezugi/gonzoquest",
      code: "1100018",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/02.jpg", alt: "" },
    },

    asgardianstones: {
      href: "/casino/ezugi/asgardianstones",
      code: "1100096",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/03.jpg", alt: "" },
    },
    secrets: {
      href: "/casino/ezugi/secrets",
      code: "1100106",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/04.jpg", alt: "" },
    },
    grandwheel: {
      href: "/casino/ezugi/grandwheel",
      code: "1100150",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/05.jpg", alt: "" },
    },
  },
  Proivdergames: {
    Evolution: {
      href: "/casino/evolution",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/provider/01.png", alt: "" },
    },
    ezugi: {
      href: "/casino/aggapezugi-ezugi-lobby",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/provider/02.png", alt: "" },
    },

    supernova: {
      href: "/casino/supernowa",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/provider/03.png", alt: "" },
    },
    xpg: {
      href: "/casino/xpg",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/provider/04.png", alt: "" },
    },
  },
  PaymentMethod: {
    netbanking: {
      href: "/casino/Evolution",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/payments/netbanking.svg", alt: "" },
    },
    upi: {
      href: "/casino/aggapezugi-ezugi-lobby",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/payments/upi.svg", alt: "" },
    },

    visa: {
      href: "/casino/supernova",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/payments/visa.svg", alt: "" },
    },
    mastercard: {
      href: "/casino/xpg",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/payments/mastercard_white.svg", alt: "" },
    },
    paytm: {
      href: "/casino/xpg",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/payments/paytm.svg", alt: "" },
    },
    Phonepe: {
      href: "/casino/xpg",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/payments/phonepe.svg", alt: "" },
    },
    gpay: {
      href: "/casino/xpg",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/payments/gpay.svg", alt: "" },
    },
    airtel: {
      href: "/casino/xpg",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/payments/airtel.svg", alt: "" },
    },
  },

  spribeGames: {
    aviator: {
      // redirectUrl: "/casino/aggapspribe-aviator",
      redirectUrl: "/casino/aggapspribe-aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Aviator-new.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    goal: {
      // redirectUrl: "/casino/aggapspribe-goal",
      redirectUrl: "/casino/aggapspribe-goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Goal-new.webp",
      alt: "",
      name: "Goal",
      providerName: "Spribe",
    },
    dice: {
      // redirectUrl: "/casino/aggapspribe-dice",
      redirectUrl: "/casino/aggapspribe-dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Dice-new.webp",
      alt: "",
      name: "Dice",
      providerName: "Spribe",
    },
    plinko: {
      // redirectUrl: "/casino/aggapspribe-plinko",
      redirectUrl: "/casino/aggapspribe-plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Plinko-new.webp",
      alt: "",
      name: "Plinko",
      providerName: "Spribe",
    },
    hilo: {
      // redirectUrl: "/casino/aggapspribe-hilo",
      redirectUrl: "/casino/aggapspribe-hilo",
      code: "hi-lo",
      casino: "spribe",
      provider: "hi-lo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Hilo-new.webp",
      alt: "",
      name: "Hilo",
      providerName: "Spribe",
    },
    keno: {
      // redirectUrl: "/casino/aggapspribe-keno",
      redirectUrl: "/casino/aggapspribe-keno",
      code: "keno",
      casino: "spribe",
      provider: "keno",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Keno-new.webp",
      alt: "keno",
      name: "Keno",
      providerName: "Spribe",
    },
    miniroulette: {
      // redirectUrl: "/casino/aggapspribe-miniroulette",
      redirectUrl: "/casino/aggapspribe-mini-roulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/MiniRoulette-new.webp",
      alt: "",
      name: "Mini Roulette",
      providerName: "Spribe",
    },

    mines: {
      // redirectUrl: "/casino/aggapspribe-mines",
      redirectUrl: "/casino/aggapspribe-mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Mines.webp",
      alt: "",
      name: "Mines",
      providerName: "Spribe",
    },
    hotline: {
      // redirectUrl: "/casino/aggapspribe-hotline",
      redirectUrl: "/casino/aggapspribe-hotline",
      code: "hotline",
      casino: "spribe",
      provider: "hotline",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/HotlineNew.jpg",
      alt: "hotline",
      name: "Hotline",
      providerName: "Spribe",
    },
    PilotChicken: {
      redirectUrl: "/casino/aggapspribe-pilot-chicken",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/pilotchicken.webp",
      alt: "Pilot Chicken",
      name: "Pilot Chicken",
    },
    GatesofEgypt: {
      redirectUrl: "/casino/aggapspribe-gates-of-egypt",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/gatesofegypt.webp",
      alt: "Gates of Egypt",
      name: "Gates of Egypt",
    },
    NeoVegas: {
      redirectUrl: "/casino/aggapspribe-neo-vegas",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/neovegas.webp",
      alt: "Neo Vegas",
      name: "Neo Vegas",
    },
    CrystalsFall: {
      redirectUrl: "/casino/aggapspribe-crystal-fall",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/crystalfall.webp",
      alt: "Crystal Fall",
      name: "Crystal Fall",
    },
    Trader: {
      redirectUrl: "/casino/aggapspribe-trader",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/trader.webp",
      alt: "Trader",
      name: "Trader",
    },
    Keno80: {
      redirectUrl: "/casino/aggapspribe-keno-80",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/multikeno.webp",
      alt: "Keno 80",
      name: "Keno 80",
    },
    Balloon: {
      redirectUrl: "/casino/aggapspribe-balloon",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/balloon.webp",
      alt: "Balloon",
      name: "Balloon",
    },
  },
};
